export default __webpack_public_path__ + "static/media/BYLCx The Art of Public Speaking.72edb1b4.webp";